import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class AbilitiesService {
  constructor(private api: ApiService) {}

  getAbilities(): Promise<IAbilities[]> {
    return this.api.get('/ap/abilities').toPromise();
  }
}
